const i18n = require("@/i18n");

module.exports = {
  id: "Stylable_StylableButton_15",
  preset: { rect: { width: 176, height: 86, x: 148, y: 374 }, tags: null },
  structure: {
    parent: "comp-knzvqsjj",
    style: {
      styleType: "custom",
      componentClassName: "wixui.StylableButton",
      style: {
        groups: {},
        properties: {
          "$st-css":
            ":import{\n    -st-from: 'wix-ui-santa/index.st.css';\n    -st-named: StylableButton\n}\n.root{\n    -st-extends: StylableButton;\n    transition: all 0.2s ease, visibility 0s;\n    background: no-repeat padding-box border-box 51% 43%/cover scroll wixMediaUrl(a3c153_b61b624117074ddc925cfccaabf87368~mv2.png,1920,1080), #6298AA;\n    border: 0px solid rgb(98, 152, 170)\n}\n.root:hover{\n    background: #417586;\n    border: 0px solid rgb(65, 117, 134)\n}\n.root:hover::label{\n    color: #FFFFFF\n}\n.root:disabled{\n    background: #E2E2E2\n}\n.root:disabled::label{\n    color: #8F8F8F\n}\n.root:disabled::icon{\n    fill: #8F8F8F\n}\n.root::container{\n    transition: inherit\n}\n.root::label{\n    transition: inherit;\n    color: value(site_1_1);\n    font-style: normal;\n    font-weight: 700;\n    letter-spacing: 0.2em;\n    font-family: avenir-lt-w01_85-heavy1475544,sans-serif;\n    font-size: 18px\n}\n.root::icon{\n    transition: inherit;\n    width: 10px;\n    height: 10px;\n    fill: value(site_1_1);\n    display: none\n}\n.root:hover::icon{\n    fill: value(site_1_5)\n}",
        },
        propertiesSource: { "$st-css": "value" },
      },
      pageId: "",
      compId: "",
      type: "ComponentStyle",
      metaData: {
        isHidden: false,
        sig: "4ie-288",
        pageId: "c1dmp",
        schemaVersion: "1.0",
        isPreset: false,
      },
      skin: "wixui.skins.Skinless",
    },
    activeModes: {},
    data: {
      type: "StylableButton",
      metaData: {
        isHidden: false,
        sig: "5vr-415",
        pageId: "c1dmp",
        schemaVersion: "1.0",
        isPreset: false,
      },
      label: i18n.translate("buttons_text_preset_join_us_bg"),
      svgId: "b861b040274141de9c08999ec3b76edf.svg",
    },
    components: [],
    componentType: "wixui.StylableButton",
    id: "comp-km95zqri",
    layout: {
      x: 161,
      fixedPosition: false,
      y: 388,
      scale: 1,
      height: 58,
      rotationInDegrees: 0,
      width: 153,
    },
    type: "Component",
    props: {
      type: "StylableButtonProperties",
      metaData: { schemaVersion: "1.0", sig: "b80-855", pageId: "c1dmp" },
    },
    metaData: { sig: "inq-316", pageId: "c1dmp" },
    skin: "wixui.skins.Skinless",
  },
};
